import { Link } from "react-router-dom";
import { hotList } from "@/mocks/site";

export default function NewsTicker() {
  const items = hotList.slice(0, 8);
  const loop = [...items, ...items];

  return (
    <div className="flex w-full items-center gap-3 border-y border-background-200 bg-background-100 py-2.5">
      <span className="ml-4 flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50 md:ml-6">
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-flashlight-fill w-3.5 h-3.5 flex items-center justify-center"></i>
        </span>
        实时播报
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-ticker items-center">
          {loop.map((item, idx) => (
            <Link
              key={`${item.rank}-${idx}`}
              to={`/article/${item.linkId}`}
              className="mx-6 inline-flex shrink-0 items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              <span className="flex h-3 w-3 items-center justify-center text-primary-400">
                <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
              </span>
              <span className="whitespace-nowrap">{item.keyword}</span>
              <span className="whitespace-nowrap text-xs text-foreground-400">{item.heat}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}